
import Vue, { PropType } from "vue";
import { mapGetters, mapState } from "vuex";
import moment from "moment";
import { dispatch, ListQuery } from "@/store";

export default Vue.extend({
  name: "VBalanceList",
  props: {
    query: Object as PropType<ListQuery>
  },
  data() {
    return {
      moment
    };
  },
  computed: {
    ...mapGetters({ coinName: "coinName" }),
    ...mapState("app", {
      isCN: "isCN",
      isMobile: "isMobile"
    }),
    ...mapState("assets", {
      images: "images"
    }),
    ...mapState("user", {
      list: "balanceList",
      balanceQuery: "balanceQuery",
      count: "balanceCount"
    })
  },
  methods: {
    getList(page_number: number) {
      dispatch.userBalanceList({
        ...this.balanceQuery,
        ...this.query,
        page_number
      });
    },
    moreData() {
      this.getList(Number(this.balanceQuery.page_number) + 1);
    }
  },
  watch: {
    query(query, old) {
      if (JSON.stringify(query) !== JSON.stringify(old)) {
        this.getList(1);
      }
    }
  },
  mounted() {
    this.getList(1);
  }
});
